import { createStandardAction } from 'typesafe-actions';

export const setCurrentCard = createStandardAction('Board/SET_CURRENT_CARD')<{
  currentCard: any;
}>();

export default {
  setCurrentCard,
};
